const wrapperStyle = (theme) => ({
	wrapper: {
		[theme.breakpoints.down('lg')]: {
			width: '100%',
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: '1280px',
			width: '100%',
		},
		margin: 0,
	},
	alignCenter: {
		margin: 'auto',
	},
});

export default wrapperStyle;
